import React from "react";
import { Switch, Stack } from "@mui/material";
import { DarkMode, LightMode } from "@mui/icons-material";
import { useThemeMode } from "../Theme";

export default function ThemeToggle() {
  const { mode, setMode } = useThemeMode();

  const handleChange = () => {
    setMode(mode === "light" ? "dark" : "light");
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      marginLeft="2em"
    >
      <LightMode />
      <Switch
        checked={mode === "dark"}
        onChange={handleChange}
        sx={{
          "& .MuiSwitch-switchBase": {
            color: "#000000", // thumb color (unchecked)
          },
          "& .MuiSwitch-track": {
            backgroundColor: "#ffffff", // track color (unchecked)
          },
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: "#fff", // thumb color when checked
            "& + .MuiSwitch-track": {
              backgroundColor: "#000000", // track color when checked
            },
          },
        }}
      />
      <DarkMode />
    </Stack>
  );
}